module.exports = __webpack_public_path__ + "img/11.e74b45b7.png";